
import { compose } from 'recompose';
import styled from 'styled-components';
import { hot } from 'react-hot-loader';
import React, { useEffect, useState } from 'react';
import axios from "axios";
import { Card, Icon, Image, Responsive } from 'semantic-ui-react';
import Remarks from 'op/components/remarks';
import CardWrapper from './card-wrapper';
import { withPersonSelection } from './info-card.helper';
import url from 'url';
import {withAxios} from 'op/components/auth';

const DeafultImageWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 10em;
	height: 10em;
	margin: auto;
`;

const PersonDisplay = ({ person, imageError, setImageError,axios }) => {
	  const [alerts, setAlerts] = useState();
	  
	  useEffect(() => {	
		var person_id=person.person_id;
		const reqestURL = url.format({
			pathname: '/api/tasks/compliance_details_2_person',
			query: { person_id}
		});	
          axios.get(reqestURL).then(response => {
            setAlerts(response.data);
	 	    }).catch(ex => console.log(ex.message));
      }, []);
	return (
		<CardWrapper>
			<Card className='person-info'>
				{
					imageError ? (
						<DeafultImageWrapper>
							<Icon name='user' size='massive' />
						</DeafultImageWrapper>
					) : (
						<Image style={{ objectFit: 'contain' }} src={`/api/common/persongetpicture/${person.person_id}`} onError={() => setImageError(true)} />
					)
				}
				<Card.Content>
					<Card.Header>
						{person.name} / {person.id}
					</Card.Header>
					{person.isAus ?
						<Card.Meta>
							{person.unit.name}
						</Card.Meta>
						:
						<Card.Meta>
							{person.unit.name}/{person.job.name}
						</Card.Meta>
					}
					{alerts != "" ? (
						<Card.Description>
							<Remarks value={alerts} />
						</Card.Description>) : null} 
					
						
				</Card.Content>
				</Card>
		</CardWrapper>
	)
};

export default compose(
	withPersonSelection,
	hot(module),
	withAxios
)(PersonDisplay);